import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [state, setState] = useState({ status: "loading", user: null, tenant: null, plan: null });

  const load = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setState({ status: "ok", user: data.user, tenant: data.tenant, plan: data.plan });
    } catch {
      setState({ status: "anon", user: null, tenant: null, plan: null });
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setState({ status: "ok", user: data.user, tenant: data.tenant, plan: data.plan });
    return data;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    setState({ status: "anon", user: null, tenant: null, plan: null });
  };

  return (
    <AuthContext.Provider value={{ ...state, login, logout, reload: load }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
